import {createAsyncThunk} from '@reduxjs/toolkit';
import GoalsService from './GoalsService';
import {GoalModelType} from '../models/GoalModelType';
import {normalizeLifestyleGoalForSufficiency} from './normalizeLifestyleGoalForSufficiency';

export interface FetchGoalsModelArgs {
    profileId: string;
    previousGoalModel: GoalModelType;
    handleError: (error: unknown) => void;
    enableEnhancedLifestyleFunding?: boolean;
}

export const fetchGoalsModel = createAsyncThunk<
    GoalModelType,
    FetchGoalsModelArgs
>('goalModel/fetchGoalsModel', async ({profileId, previousGoalModel, handleError, enableEnhancedLifestyleFunding}) => {
    const goalModel = await GoalsService.getGoalsModel(
        profileId,
        previousGoalModel,
        handleError,
        enableEnhancedLifestyleFunding
    );
    return await normalizeLifestyleGoalForSufficiency(goalModel);
});
